import { render, staticRenderFns } from "./GoodsForm.vue?vue&type=template&id=0306b6bc&scoped=true&"
import script from "./GoodsForm.vue?vue&type=script&lang=js&"
export * from "./GoodsForm.vue?vue&type=script&lang=js&"
import style0 from "./GoodsForm.vue?vue&type=style&index=0&id=0306b6bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0306b6bc",
  null
  
)

export default component.exports